import { HeldTrainingRecordResponse } from "../contracts/HeldTrainingRecordResponse";
import { PaginatedResult } from "../../sessions/contracts/PaginatedResult";
import { HeldTrainingRecord, HeldTrainingRecordPage } from "../models/HeldTrainingRecord";

export const mapResponseToHeldTrainingRecord = (resp: HeldTrainingRecordResponse): HeldTrainingRecord => ({
  enrolmentId: resp.enrolmentId,
  learnerName: resp.learnerName ?? "",
  programmeName: resp.programmeName ?? "",
  heldUntil: resp.heldUntil,
});

/** A missing page reads as no records. */
export const mapResponseToHeldTrainingRecordPage = (
  resp: PaginatedResult<HeldTrainingRecordResponse> | null | undefined
): HeldTrainingRecordPage => ({
  records: (resp?.items ?? []).map(mapResponseToHeldTrainingRecord),
  totalCount: resp?.totalCount ?? 0,
  hasNextPage: resp?.hasNextPage ?? false,
});
